import MyProfileApis from '../../apis/aeMyProfile';
import ResumeApis from '../../apis/resume';
import { GET_PROFILE, HIDE_TOAST, SHOW_TOAST, EDIT_PROFILE } from '../../types';
import { showToast } from '../aeToast';
import { signOut } from '../auth';

import { ERROR_MSG, ERROR_MSG_401 } from '../../../constants';

export const getProfile =
  (ctx = {}) =>
  (dispatch, getstate) =>
    new Promise((resolve, reject) => {
      const state = getstate();
      const user = state.currentUser.data;

      if (!user) {
        return;
      }

      const callApi = async () => {
        try {
          const res = await MyProfileApis.getProfile(ctx.req);

          if (res.status === 500) {
            throw res;
          }

          if (res.status === 401) {
            if (ctx.res) {
              ctx.res.clearCookie('access-token', { path: process.env.DOMAIN });
            }

            dispatch(showToast('error', ERROR_MSG_401));
            dispatch(signOut());
          }

          const res_data = await res.json();

          if (!res.ok) {
            throw res_data;
          } else {
            resolve(res_data);
            dispatch({ type: `${GET_PROFILE}_success`, payload: res_data });
          }
        } catch (err) {
          reject(err);
          const payload = err && err.message ? err : { message: ERROR_MSG };

          dispatch({ type: `${GET_PROFILE}_failed`, payload });
        }
      };

      dispatch({ type: `${GET_PROFILE}_started` });

      return Promise.resolve(callApi());
    });

export const createProfile = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await MyProfileApis.createProfile(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Profile created successfully.' }
          });
          dispatch({ type: `${GET_PROFILE}_success`, payload: res_data });
          resolve('success');
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${GET_PROFILE}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const updateProfile = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await MyProfileApis.updateProfile(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Profile details updated successfully.' }
          });
          dispatch({ type: `${EDIT_PROFILE}_success`, payload: res_data });
          resolve('success');
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${EDIT_PROFILE}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const createResume = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await ResumeApis.createResume(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Resume created successfully.' }
          });

          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${SHOW_TOAST}`, payload: { type: 'error', message: payload.message } });
        reject(payload);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const searchResume = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await ResumeApis.searchResume(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        reject(payload);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });
